import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LoggerService } from '@app/core/services/logger.service';

const logger = new LoggerService('Main');

export function getBaseUrl() {
  const baseUrl = document.getElementsByTagName('base')[0].href;
  return baseUrl.replace(/^http[s]?:/, '');
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch(() => {
    logger.error('Ocurrió un error en la aplicación. Por favor, inténtelo de nuevo más tarde.');
  });
